import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee822a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Para usufluir de todas as funcionalidades do nosso aplicativo precisamos do seu CPF para continuar ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Informe seu CPF ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Confirmar CPF")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Para usufluir de todas as funcionalidades do nosso aplicativo precisamos do seu Número de Telefone Celular para continuar ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Celular")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Confirmar Celular")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu telefone celular ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Informe o código ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Confirmar Celular")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Login com código ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Receber código de acesso por e-mail ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu e-mail ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Redefinir Senha ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Você receberá um código de recuperação de senha por e-mail ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Digite o código enviado para seu e-mail ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Sua senha precisa: ")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Conter ao menos um número ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Conter ao menos uma letra maiúscula ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" As senhas digitadas não são iguais ")
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Enviar Solicitação")
const _hoisted_60 = { class: "ion-padding background" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logo.svg" })
], -1))
const _hoisted_62 = {
  novalidate: "",
  class: "ion-padding"
}
const _hoisted_63 = /*#__PURE__*/_createTextVNode("EMAIL")
const _hoisted_64 = { "padding-left": "" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode("SENHA")
const _hoisted_68 = { "padding-left": "" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Entrar")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" ou então ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Entrar com codigo único")
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Esqueceu a senha? ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Clique aqui")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.capturaCPF
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.goto();_ctx.capturaCPF=false}),
            color: "light",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2,
                  _createVNode(_component_ion_col, {
                    class: "font-poppins-extra font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-poppins-extra font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-raleway font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        class: "input-cadastro-cpf",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cadastro.cpf) = $event)),
                        onMaska: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cadastro.cpf_v = $event.target.dataset.maskRawValue))
                      }, null, 544), [
                        [_vModelText, _ctx.cadastro.cpf],
                        [_directive_maska, ['###.###.###-##', '##.###.###/####-##']]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateNovosDados())),
                        size: "large",
                        shape: "round",
                        color: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.capturaCELULAR
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.goto();_ctx.capturaCELULAR=false}),
            color: "light",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              (!_ctx.cadastro.pin)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-extra font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _hoisted_9,
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-raleway font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            class: "input-cadastro-mobile",
                            placeholder: "(xx)xxxxx-xxxx",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cadastro.celular) = $event)),
                            onMaska: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cadastro.celular_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.celular],
                            [_directive_maska, ['(##)# ####-####', '(##)# ####-####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15,
                          _hoisted_16,
                          _createVNode(_component_ion_button, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.callValidacao())),
                            size: "large",
                            shape: "round",
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-poppins-extra font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-extra font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-extra font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_otp_input, {
                            ref: "otpInput",
                            "input-classes": 'input-custom-cadastro',
                            separator: "     ",
                            "num-inputs": 4,
                            "should-auto-focus": false,
                            "is-input-num": true,
                            onOnComplete: _ctx.handleOnComplete,
                            placeholder: ['*', '*', '*', '*']
                          }, null, 8, ["onOnComplete"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createVNode(_component_ion_button, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateNovosDados())),
                            size: "large",
                            shape: "round",
                            color: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal_codigo",
        onDidDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.capturaCodUnico=false)),
        "is-open": _ctx.capturaCodUnico,
        "initial-breakpoint": 0.85,
        breakpoints: [0, 0.85, 0.85, 0.85]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.goto();_ctx.capturaCodUnico=false}),
            color: "dark",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
              _hoisted_27
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding background" }, {
            default: _withCtx(() => [
              _hoisted_28,
              _createVNode(_component_swiper, {
                allowTouchMove: false,
                zoom: false,
                onSwiper: _ctx.onSwiper
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _hoisted_29,
                          _createVNode(_component_ion_col, {
                            class: "font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          }),
                          _hoisted_31,
                          _hoisted_32,
                          _createVNode(_component_ion_col, {
                            class: "font-raleway font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.username,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.username) = $event)),
                                onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.username=$event.target.value)),
                                name: "username",
                                class: "custom",
                                placeholder: "digite seu email",
                                type: "email",
                                spellcheck: "false",
                                autocapitalize: "off",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_33,
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36,
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onPinCode())),
                                size: "large",
                                shape: "round",
                                color: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_otp_input, {
                                ref: "otpInput",
                                "input-classes": 'input-cadastro-pincode',
                                separator: "       ",
                                "num-inputs": 6,
                                "should-auto-focus": false,
                                "is-input-num": true,
                                onOnComplete: _ctx.handleOnComplete,
                                placeholder: ['*', '*', '*', '*', '*', '*']
                              }, null, 8, ["onOnComplete"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-raleway font-12",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_39,
                              _hoisted_40,
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onPinCode())),
                                    size: "large",
                                    shape: "round",
                                    color: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_41
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSwiper"]),
              _createVNode(_component_ion_row)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal_codigo",
        onDidDismiss: _cache[26] || (_cache[26] = ($event: any) => (_ctx.capturaNovaSenha=false)),
        "is-open": _ctx.capturaNovaSenha,
        "initial-breakpoint": 0.95,
        breakpoints: [0, 0.95, 0.95, 0.95]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.goto();_ctx.capturaNovaSenha=false}),
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
              _hoisted_42
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding background" }, {
            default: _withCtx(() => [
              _hoisted_43,
              _createVNode(_component_swiper, {
                allowTouchMove: false,
                zoom: false,
                onSwiper: _ctx.onSwiper
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_44
                            ]),
                            _: 1
                          }),
                          _hoisted_45,
                          _hoisted_46,
                          _createVNode(_component_ion_col, {
                            class: "font-raleway font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.username,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.username) = $event)),
                                onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.username=$event.target.value)),
                                name: "username",
                                class: "custom",
                                placeholder: "digite seu email",
                                type: "email",
                                spellcheck: "false",
                                autocapitalize: "off",
                                required: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_47,
                          _hoisted_48,
                          _hoisted_49,
                          _hoisted_50,
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onPinLostCode())),
                                size: "large",
                                shape: "round",
                                color: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_51
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_52
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "font-poppins-extra font-15",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_otp_input, {
                                ref: "otpInput",
                                "input-classes": 'input-custom-cadastro',
                                separator: "     ",
                                "num-inputs": 6,
                                "should-auto-focus": false,
                                "is-input-num": true,
                                onOnComplete: _ctx.handleOnComplete,
                                placeholder: ['*', '*', '*', '*', '*', '*']
                              }, null, 8, ["onOnComplete"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-12",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_53
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.minLength.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Ter pelo menos " + _toDisplayString(_ctx.v$.cadastro.password.minLength.$params.min) + " caracteres ", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.hasnumber.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _hoisted_54
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-11 light-gray",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.v$.cadastro.password.hasupper.$invalid ? _ctx.close :_ctx.checkmark
                                  }, null, 8, ["icon"]),
                                  _hoisted_55
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-15",
                                size: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.cadastro.password,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.cadastro.password) = $event)),
                                    onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.cadastro.password=$event.target.value)),
                                    name: "username",
                                    class: "custom",
                                    placeholder: "Nova senha",
                                    type: _ctx.passwordType?'password':'text',
                                    spellcheck: "false",
                                    autocapitalize: "off",
                                    required: ""
                                  }, null, 8, ["modelValue", "type"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-raleway font-30",
                                size: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.passwordType?_ctx.eyeOff:_ctx.eye,
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.passwordType=!_ctx.passwordType))
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-poppins-extra font-15",
                                size: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.cadastro.password_conf,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.cadastro.password_conf) = $event)),
                                    onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.cadastro.password_conf=$event.target.value)),
                                    name: "password",
                                    class: "custom",
                                    placeholder: "Confirmar nova senha",
                                    type: _ctx.passwordType?'password':'text',
                                    spellcheck: "false",
                                    autocapitalize: "off",
                                    required: ""
                                  }, null, 8, ["modelValue", "type"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                class: "font-raleway font-30 light-gray",
                                size: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.passwordTypeConf?_ctx.eyeOff:_ctx.eye,
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.passwordTypeConf=!_ctx.passwordTypeConf))
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              (_ctx.cadastro.password!=_ctx.cadastro.password_conf)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    class: "font-raleway font-11 light-gray",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
                                      _hoisted_56
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-raleway font-12",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_57,
                              _hoisted_58,
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onPinLostCode())),
                                    size: "large",
                                    shape: "round",
                                    color: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_59
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSwiper"]),
              _createVNode(_component_ion_row)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.voltar())),
                      size: "large",
                      fill: "#fff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.chevronBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "9",
                class: "font-poppins-extra font-25"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRef,
            header: "Atenção",
            message: "Email ou Senha Inválidos",
            buttons: ['OK'],
            onDidDismiss: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isOpenRef=false))
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRefCode,
            header: "Atenção",
            message: "Código digitado inválido",
            buttons: ['OK'],
            onDidDismiss: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isOpenRefCode=false))
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_alert, {
            "is-open": _ctx.isOpenRefCodeEmail,
            header: "Atenção",
            message: "Email digitado não localizado<br>Faça seu <b>cadastro</b> agora mesmo!",
            buttons: ['OK'],
            onDidDismiss: _cache[30] || (_cache[30] = ($event: any) => {_ctx.gotoCadastro();_ctx.isOpenRefCodeEmail=false})
          }, null, 8, ["is-open"]),
          _createVNode(_component_ion_loading, { "is-open": _ctx.isOpenLoading }, null, 8, ["is-open"]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("form", _hoisted_62, [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        position: "stacked",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_63
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.username,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.username) = $event)),
                        onInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.username=$event.target.value)),
                        name: "username",
                        type: "email",
                        spellcheck: "false",
                        autocapitalize: "off",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, { color: "danger" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("p", _hoisted_64, "Digite seu EMAIL", 512), [
                        [_vShow, !_ctx.usernameValid || _ctx.submitted == true]
                      ])
                    ]),
                    _: 1
                  }),
                  _hoisted_65,
                  _hoisted_66,
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        position: "stacked",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_67
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.passwords,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.passwords) = $event)),
                        onInput: _cache[34] || (_cache[34] = ($event: any) => (_ctx.passwords=$event.target.value)),
                        name: "password",
                        type: "password",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_text, { color: "danger" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("p", _hoisted_68, "Digite sua Senha", 512), [
                        [_vShow, !_ctx.passwordValid || _ctx.submitted == true]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onLogin(_ctx.username, _ctx.passwords))),
                        color: "jauserve",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_69
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "ion-text-center" }, {
                    default: _withCtx(() => [
                      _hoisted_70
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { "responsive-sm": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.capturaCodUnico=true)),
                        color: "light",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_71
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_72,
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-right",
                    size: "7"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_73
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.capturaNovaSenha=true)),
                        color: "danger",
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_74
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}